import { useMemo } from 'react';
import { FieldListObject } from '@fabric-ui/components';
import { useAvContext } from '../context/AvContextProvider';

const useGlobalInteractiveFilters = (): FieldListObject[] => {
  const {
    accountEntities: { aggProjs },
    calculatedDimensions,
  } = useAvContext();
  return useMemo(() => {
    const aggFields = Object.values(aggProjs).reduce(
      (allFieldsToFilterBy, { fieldList: { INTERACTIVE } }) => ({
        ...allFieldsToFilterBy,
        ...INTERACTIVE.reduce((projFieldsToFilterBy, field) => {
          const key = `${field.mainProjId.name} - ${field.group} - ${field.name}`;
          return field.visibilityConfig.config.hidden
            ? projFieldsToFilterBy
            : {
                ...projFieldsToFilterBy,
                [key]: {
                  ...field,
                  otherAliases: [...(allFieldsToFilterBy[key]?.otherAliases ?? []), field.value],
                },
              };
        }, {}),
      }),
      {}
    );

    const calcFields = calculatedDimensions.all.reduce((acc, calcDim) => {
      const key = `calculated - ${calcDim.systemName}`;
      return calcDim.hidden
        ? acc
        : {
            ...acc,
            [key]: {
              value: calcDim.systemName,
              title: calcDim.displayName,
              name: calcDim.systemName,
              mainProjId: { name: 'calculated' },
              otherAliases: [calcDim.systemName],
            },
          };
    }, {});

    return [...Object.values(aggFields), ...Object.values(calcFields)] as FieldListObject[];
  }, [aggProjs, calculatedDimensions.all]);
};

export default useGlobalInteractiveFilters;
